import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  confirmDelete,
  ErrorMsg,
  GetFormData,
  InfoIcon,
  sessionUser,
  ValidateForm,
} from "../../../Util/common";

import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { KendoTreeTable } from "../../../Kendo/kendo_treetable";
import { KendoMultiSelect } from "../../../Kendo/kendo_multiselect";
import { KendoLoader } from "../../../Kendo/kendo_loader";
import {
  CorebaseURL,
  corefetch,
  corepost,
  ImageURL,
} from "../../../Util/axios_core_helper";

export const RentalGuideline = () => {
  const [MainPage, setMainPage] = useState({
    rentalGuidlinesID: 0,
    MainDescription: "",
    Image: "",
    OldimagePath: "",
  });
  const [SubPage, setSubPage] = useState({
    rentalGuidlinesID: 0,
    Title: "",
    Description: "",
    SortOrder: 0,
  });

  const [refreshflag, setrefreshflag] = useState(0);
  const [editVisible, setEditVisible] = useState(false);
  const [RentalHighlightseditVisible, setRentalHighlightseditVisible] =
    useState(false);

  const [GuidelineeditVisible, setGuidelineeditVisible] = useState(false);
  const [error, setError] = useState({});
  const modalRef = useRef(null);
  const GuidelinemodalRef = useRef(null);
  const { selDisplayedInIds } = useSelector((state) => state.VendorServices);
  const [MainDescriptionData, setMainDescriptionData] = useState([]);

  const dispatch = useDispatch();
  const [Loading, setLoading] = useState(false);
  const [VendorGridList, setVendorGridList] = useState([]);
  const [VTDup, setVTDup] = useState(false);
  const [refreshGrid, setrefreshGrid] = useState(0);
  const [HideAdd, setHideAdd] = useState(false);

  const Parentscolumns = [
    {
      field: "rentalGuidlinesID",
      filterable: false,
      hidden: true,
    },

    {
      field: "mainDescription",
      title: "Main Description",
      width: 150,
    },
    {
      template: function (e) {
        if (e.imagePath) {
          return `<img src="${ImageURL}${e.imagePath}" width="40px" height="40px" />`;
        }
        return "";
      },
      title: "Image",
      width: 60,
    },
  ];

  const childColumn = [
    {
      field: "rentalGuidlinesID",
      hidden: true,
    },
    { field: "sortOrder", hidden: true },
    {
      field: "title",
      title: "Title",
    },
    {
      field: "description",
      title: "Description",
      template: function (e) {
        const maxLength = 50;
        return e.description?.length > maxLength
          ? `${e.description.substring(0, maxLength)}...`
          : e.description;
      },
    },
  ];
  const handleToggleClick = async (id, newStatus) => {
    await corefetch(
      `PreferedVendors/UpdateGuidelineStaus?GuidelineID=${id}&Status=${newStatus}&ModifiedBy=${sessionUser()}`,
      true,
      false,
      false,
      true
    );
  };

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (event.target.classList.contains("status-toggle")) {
        const id = event.target.getAttribute("data-id");
        const newStatus = event.target.checked ? "Active" : "InActive";
        handleToggleClick(id, newStatus);
      }
    };

    // Add event listener
    document.addEventListener("click", handleDocumentClick);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    const maxSizeInKB = 500;
    const maxSizeInBytes = maxSizeInKB * 1024;
    let oversize = false;
    oversize = MainPage.Image?.size > maxSizeInBytes;

    const err = ValidateForm(e);
    if (err) {
      setError(err);
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: oversize,
      }));
    } else if (!oversize) {
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
      }));
      const formData = new FormData();

      formData.append("rentalGuidlinesID", MainPage.rentalGuidlinesID);
      formData.append("mainDescription", MainPage.MainDescription);
      formData.append("OldimagePath", MainPage.OldimagePath);
      if (MainPage.Image) {
        formData.append("Image", MainPage.Image);
      }
      formData.append("savedBy", sessionUser());

      try {
        await corepost(
          "RentalGuidlines/InsertUpdateGuidlinesDetails",
          formData,
          true,
          true,
          false,
          false
        );
        setrefreshflag(refreshflag + 1);
        clearForm();
        $("#VendorServices-cancel").click();
      } catch (error) {
        console.error("Error while submitting the form:", error);
      }
    }
  };

  const onRentalHighlightsSubmit = async (e) => {
    e.preventDefault();
    const err = ValidateForm(e);
    if (err) {
      setError(err);
    } else {
      setLoading(true);
      const formData = new FormData();
      formData.append("rentalGuidlinesID", SubPage.rentalGuidlinesID);
      formData.append("title", SubPage.Title);
      formData.append("description", SubPage.Description);
      formData.append("SavedBy", sessionUser());
      try {
        await corepost(
          "RentalGuidlines/InsertUpdateRentalGuidlinesSubPage",
          formData,
          true,
          true,
          false,
          false
        );
        setLoading(false);
        const modalElement = document.getElementById("add_Guideline");
        const modalInstance = bootstrap.Modal.getInstance(modalElement);
        if (modalInstance) {
          modalInstance.hide();
        }
        refreshChildGrd();
        clearRentalHighlights();
      } catch (error) {
        console.error("Error while submitting the form:", error);
      }
    }
  };

  const onParentEditClick = async (e) => {
    let temp = MainPage;
    MainPage.rentalGuidlinesID = e.rentalGuidlinesID;
    MainPage.MainDescription = e.mainDescription;
    MainPage.Image = e.imagePath;
    MainPage.OldimagePath = e.imagePath;
    setMainPage(temp);
    setEditVisible(true);

    const modal = new bootstrap.Modal(
      document.getElementById("add_VendorServices")
    );
    modal.show();
  };

  const onRentalHighlightsAdd = async (e) => {
    const modal = new bootstrap.Modal(document.getElementById("add_Guideline"));
    modal.show();
  };

  const onhighlightsEditClick = async (e) => {
    setRentalHighlightseditVisible(true);
    setSubPage((prev) => ({
      ...prev,
      rentalGuidlinesID: e.child.rentalGuidlinesID,
      Title: e.child.title,
      Description: e.child.description,
    }));
    const modal = new bootstrap.Modal(document.getElementById("add_Guideline"));
    modal.show();
  };

  const handlePatentDeleteClick = async (e) => {
    const onDelete = () => {
      corefetch(
        `PreferedVendors/DeletePreferedVendors?preferedVendorId=${
          e.vendorServicesID
        }&deletedBy=${sessionUser()}`,
        true,
        false,
        true
      ).then(() => {
        setrefreshflag((prev) => prev + 1);
      });
    };
    confirmDelete(onDelete);
  };
  const handleChildDeleteClick = async (e) => {
    const onDelete = () => {
      corefetch(
        `RentalGuidlines/DeleteRentalGuidlinesSubPage?rentalGuidlinesId=${
          e.rentalGuidlinesID
        }&deletedBy=${sessionUser()}`,
        true,
        false,
        true
      ).then(() => {
        refreshChildGrd();
      });
    };
    confirmDelete(onDelete);
  };
  const onValidation = (name, val) => {
    setError((prvErr) => {
      return {
        ...prvErr,
        [name]:
          !val || (val && val.trim() == "") || (val && val.trim().length == 0),
      };
    });
  };

  const onRowReorderChange = async (List) => {
    try {
      let rentalGuidlinesID = $(List.newRow).find("td").eq(0).text();
      let oldSortId = $(List.newRow).find("td").eq(1).text();
      let newSortId = $(List.oldRow).find("td").eq(1).text();
      await corefetch(
        `RentalGuidlines/SortRentalGuidlines?TypeId=${rentalGuidlinesID}&newSortId=${newSortId}&oldSortId=${oldSortId}`
      );
      refreshChildGrd();
    } catch (error) {
      console.error("Error during row reorder:", error);
    }
  };

  const clearForm = () => {
    setMainPage({
      rentalGuidlinesID: 0,
      MainDescription: "",
    });
    setError({});
    setEditVisible(false);

    const form = document.getElementById("form-culture-config");
    if (form) {
      form.reset();
    }
  };

  const clearRentalHighlights = () => {
    $("#Guideline-cancel").click();

    setSubPage({
      rentalGuidlinesID: 0,
      Title: "",
      Description: "",
    });
    $("#GFile").val("");
    setError({});
    setRentalHighlightseditVisible(false);
    const form = document.getElementById("Guideline-form");
    if (form) {
      form.reset();
    }
  };

  const refreshChildGrd = () => {
    $(`#reload-BannerTreetable`)
      .next()
      .find(".k-master-row")
      .each(function (index) {
        if ($(this).find("td:first").find("a:first").hasClass("k-i-collapse")) {
          $(this).next().find(".btn-refresh:first").click();
        }
      });
  };

  const fetchData = async () => {
    try {
      const list = await corefetch("PreferedVendors/GetVendorsDetails");
      setVendorGridList(list);
    } catch (error) {
      console.error("Error fetching list:", error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const list = await corefetch("RentalGuidlines/GetGuidlinesDetails");
        setMainDescriptionData(list);
        if (list && list.length > 0) {
          setHideAdd(true);
        } else {
          setHideAdd(false);
        }
      } catch (error) {
        console.error("Error fetching list:", error);
        setHideAdd(false);
      }
    };

    fetchData();
  }, [refreshflag]);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const hasAvifFile =
      file && !(file.type === "image/png" || file.type === "image/jpeg");
    if (hasAvifFile) {
      toast.error("Unsupported image format uploaded.");
      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = null;
      }
      return;
    }
    if (!file) {
      setError((prevError) => ({
        ...prevError,
        InValidFileSize: false,
        ValidFile: false,
      }));
      setMainPage((prev) => ({
        ...prev,
        Image: "",
      }));
      onValidation("Image", e.target.value);
      return;
    }

    if (file && file.type.startsWith("image/")) {
      // Valid image file
      setError({ ...error, ValidFile: false });

      const maxSizeInKB = 500;
      const maxSizeInBytes = maxSizeInKB * 1024;

      const isFileTooLarge = file.size > maxSizeInBytes;

      setError((prevError) => ({
        ...prevError,
        ValidFile: false,
        InValidFileSize: isFileTooLarge,
      }));

      if (isFileTooLarge) {
        setMainPage((prev) => ({
          ...prev,
          Image: file,
        }));
        // e.target.value = "";
      } else {
        let temp = MainPage;
        temp.Image = file;
        setMainPage(temp);
        document.getElementById("image-name").value = file;
      }

      onValidation("Image", e.target.value);
    } else {
      e.target.value = "";
      setError((prevError) => ({
        ...prevError,
        ValidFile: true,
        InValidFileSize: false,
      }));
      setMainPage((prev) => ({
        ...prev,
        Image: "",
      }));
    }
  };
  return (
    <>
      <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <h3 className="page-title">Rental Guidelines</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <li>Configuration</li>
              </li>
              <li className="breadcrumb-item active">Rental Guidelines</li>
            </ul>
          </div>
        </div>
      </div>

      <div className="card bg-white">
        <div className="card-body">
          <div className="col-auto ms-auto">
            <div className="row">
              <div className="col-sm-6"></div>
              <div className="col-auto float-end ms-auto">
                <div className="d-flex justify-content-end mb-2">
                  {!HideAdd && (
                    <Button
                      name={"Add"}
                      dataBsToggle={"modal"}
                      dataBsTarget={"#add_VendorServices"}
                      dataBsDismiss={"modal"}
                    />
                  )}
                </div>
              </div>
            </div>

            <div>
              <KendoTreeTable
                name={"BannerTreetable"}
                parentTableUrl={
                  CorebaseURL + "RentalGuidlines/GetGuidlinesDetails"
                }
                parentTableColumns={Parentscolumns}
                childTableUrl={
                  CorebaseURL + "RentalGuidlines/GetRentalGuidlinesSubPage"
                }
                childTableColumns={childColumn}
                showParentOptions={true}
                showParentAdd={true}
                showParentEdit={true}
                showParentDelete={false}
                onParentAddClick={onParentEditClick}
                onParentEditClick={onRentalHighlightsAdd}
                // onParentDeleteClick={handlePatentDeleteClick}
                showChildOptions={true}
                showChildDelete={true}
                onChildEditClick={onhighlightsEditClick}
                onChildDeleteClick={handleChildDeleteClick}
                enableRowReorderable={true}
                onRowReorder={onRowReorderChange}
                refreshWhen={refreshflag}
                parentpaggable={false}
                noteLabel="Note:"
                noteContent="This module supports drag-and-drop functionality, you can easily
                        rearrange or move data as needed."
              />
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Add VendorServices Modal --> */}
      <div
        className="modal custom-modal fade"
        id="add_VendorServices"
        role="dialog"
        ref={modalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered VendorServices"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">{editVisible ? "Edit" : "Add"}</h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearForm();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="form-culture-config" onSubmit={onSubmit}>
                <input
                  type="hidden"
                  name="ID"
                  value={MainPage.rentalGuidlinesID || 0}
                />

                {/* Single Column Layout */}
                <div className="row">
                  <div className="col-12 mb-3">
                    <div className="input-block">
                      <label className="form-label">
                        Main Description <span className="text-danger">*</span>
                        <InfoIcon content="Please provide a Main Description with a maximum length of 400 characters." />
                      </label>
                      <textarea
                        type="text"
                        maxLength={400}
                        className="form-control field"
                        name="MainDescription"
                        value={MainPage.MainDescription || ""}
                        placeholder="Main Description"
                        data-required="true"
                        onChange={(e) => {
                          setMainPage((prev) => ({
                            ...prev,
                            MainDescription: e.target.value,
                          }));
                          onValidation("MainDescription", e.target.value);
                        }}
                      />
                      {error.MainDescription && (
                        <ErrorMsg text="Main Description is required" />
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12 mb-3">
                  <div className="input-block mb-3">
                    <label className="form-label">
                      Upload Image <span className="text-danger">*</span>
                      <InfoIcon
                        content="Kindly upload an Image within 500KB size.;
                                        Please upload the image in JPEG, JPG or PNG format."
                      />
                    </label>
                    <input
                      className="form-control"
                      type="file"
                      name="file"
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                    {error.Image && <ErrorMsg text=" Image is required" />}
                    {error.ValidFile && (
                      <ErrorMsg text="Please upload Image file only" />
                    )}
                    {error.InValidFileSize && (
                      <ErrorMsg text="File size exceeds 500KB. Please upload a smaller file." />
                    )}
                  </div>
                </div>

                <div className="col-12 mb-3">
                  {MainPage.OldimagePath && MainPage.rentalGuidlinesID > 0 && (
                    <div
                      style={{
                        width: "100%",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                      }}
                    >
                      <a
                        href={`${ImageURL}${MainPage.OldimagePath}`}
                        target="_blank"
                        style={{
                          textDecoration: "underline",
                          fontSize: "13px",
                        }}
                      >
                        {MainPage.OldimagePath.split("/").pop()}
                      </a>
                    </div>
                  )}
                  <input
                    type="hidden"
                    name="Image"
                    id="image-name"
                    data-required="true"
                    value={MainPage.Image || ""}
                  />
                  <input
                    type="hidden"
                    name="OldimagePath"
                    value={MainPage.OldimagePath}
                  />
                </div>

                <div className="text-end">
                  <Button
                    name={"Cancel"}
                    isCancelButton={true}
                    id="VendorServices-cancel"
                    dataBsDismiss={"modal"}
                    onClick={() => {
                      clearForm();
                    }}
                  />
                  {/* <Button name={"Save"} /> */}
                  <Button name={editVisible ? "Update" : "Save"} />
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- /Add VendorServices Modal --> */}

      {/* <!-- Add Guideline Modal --> */}
      <div
        className="modal custom-modal fade"
        id="add_Guideline"
        role="dialog"
        ref={GuidelinemodalRef}
        aria-hidden="true"
        data-bs-backdrop="static"
      >
        <div
          className="modal-dialog modal-dialog-centered rentalHighlights"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">
                {RentalHighlightseditVisible
                  ? "Edit Guideline"
                  : "Add Guideline"}
              </h5>
              <button
                type="button"
                className="close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  clearRentalHighlights();
                }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <form id="Guideline-subForm" onSubmit={onRentalHighlightsSubmit}>
                <input
                  type="hidden"
                  name="bannerID"
                  value={SubPage.rentalGuidlinesID}
                />

                <div className="row">
                  <div className="col-md-12 mb-3">
                    <label className="form-label">
                      Title <span className="text-danger">*</span>
                      <InfoIcon content="Please provide a Title with a maximum length of 30 characters." />
                    </label>
                    <input
                      type="text"
                      maxLength={30}
                      className="form-control field"
                      name="Title"
                      value={SubPage.Title}
                      placeholder="Title"
                      data-required="true"
                      onChange={(e) => {
                        onValidation("Title", e.target.value);
                        setSubPage((prev) => ({
                          ...prev,
                          Title: e.target.value,
                        }));
                      }}
                    />
                    {error.Title && <ErrorMsg text="Title is required" />}
                  </div>
                  <div className="col-md-12 mb-3">
                    <label className="form-label">
                      Description <span className="text-danger">*</span>
                      <InfoIcon content="Please provide a Description with a maximum length of 2000 characters." />
                    </label>
                    <textarea
                      type="text"
                      maxLength={2000}
                      className="form-control field"
                      name="Description"
                      value={SubPage.Description}
                      placeholder="Description"
                      data-required="true"
                      onChange={(e) => {
                        onValidation("Description", e.target.value);
                        setSubPage((prev) => ({
                          ...prev,
                          Description: e.target.value,
                        }));
                      }}
                    />
                    {error.Description && (
                      <ErrorMsg text="Description is required" />
                    )}
                  </div>
                </div>

                {Loading ? (
                  <KendoLoader className="d-flex justify-content-end align-items-center" />
                ) : (
                  <div className="text-end">
                    <Button
                      name={"Cancel"}
                      isCancelButton={true}
                      id="Guideline-cancel"
                      dataBsDismiss={"modal"}
                      onClick={() => {
                        clearRentalHighlights();
                      }}
                    />
                    <Button
                      name={RentalHighlightseditVisible ? "Update" : "Save"}
                    />
                  </div>
                )}
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
